/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import {
  Applogo,
  Avatar_02,
  Applogo2,
  headerlogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
  Bar,
  MiniLogo
} from "../../Routes/ImagePath";

import { FaRegBell, FaRegComment } from "react-icons/fa";
import { useLocation } from "react-router-dom/dist";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { useAuth } from "context/userContext";
import Image from "components/Image";
import useWebSocket from "api/useWebsocket";
import { formatDateHandler, dateLeftHandler, timeSince } from "utils/common";

import { bulkNotificationChangeHandle, fetchNotificationData } from "store/slice/common";
import { useDispatch } from "react-redux";
import { updateNotification } from "api/services/common";

const Header = (props) => {
  // const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [isRead, setIsRead] = useState(false);

  const [flagImage, setFlagImage] = useState(lnEnglish);
  const {logout} = useAuth();
  const navigate = useNavigate();
  const {
    user,
    userLoading
} = useSelector((state) => state.user);

const { notifications,notificationLoading, sendMessage , notificationCount } = useWebSocket(user?.id)

const dispatch = useDispatch()



const viewNotificationHandler = async(val) => {
  await updateNotification(val?.id,{is_read:true})
  dispatch(fetchNotificationData({status: isRead}));

}
const filterNotifications = (e,status) => {
  e.stopPropagation(); // Prevent dropdown from closing

  setIsRead(status)
  dispatch(fetchNotificationData({status}));

}

const readDeleteNotification = (action) => {

  dispatch(bulkNotificationChangeHandle({action,status:isRead }));

}

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const themes = localStorage.getItem("theme");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  // const handleFlags = () => {
  //   setflag(!flag);
  //   setIsOpen(false);
  //   setNotifications(false);
  //   setProfile(false);
  // };
  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };
  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  // const { value } = useSelector((state) => state.user);
  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = `${user?.first_name || ""} ${user?.last_name || ""}`

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // Debugging statement
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? lnEnglish
        : lng === "fr"
          ? lnFrench
          : lng === "es"
            ? lnSpanish
            : lnGerman
    );
  };
    // Prevent closing when clicking inside
    const handleInsideClick = (event) => {
      event.stopPropagation();
    };

  const handleLogout = () =>{
    logout()
    navigate("/login")
  }
  return (
    <div className="header" style={{ right: "0px" }}>
      {/* Logo */}
      <div className="header-left">
        <Link to="/employee-dashboard"    className="logo main-logo d-flex justify-content-center align-items-center h-100">
          <img src={Applogo}  alt="img" />
        </Link>
        <Link to="/employee-dashboard"    className=" mini-logo d-flex justify-content-center align-items-center h-100 w-100">
          <img  src={MiniLogo}  alt="img" />
        </Link>
        {/* <Link to="/employee-dashboard" className="icon-logo">
          <img src={Applogo2}  style={{width:"60%"}} alt="img" />
        </Link> */}
      </div>
      {/* /Logo */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
              ? "none"
              : "",
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box d-flex">
        {/* <h2 className="font-weight-bold text-white " style={{alignSelf:"center"}} >ESS</h2> */}
        <img className="bar-image" src={Bar}  
        // style={{position:"absolute"}} 
        // className="h-100" 
        />
      </div>
      
      {/* /Header Title */}
      {/* <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link> */}
      {/* Header Menu */}
      <ul className="nav user-menu">
        {/* Search */}
        {/* <li className="nav-item">
          <div className="top-nav-search">
            <Link to="#" className="responsive-search">
              <i className="fa fa-search" />
            </Link>
            <form>
              <input
                className="form-control"
                type="text"
                placeholder="Search here"
              />
              <button className="btn" type="submit">
                <i className="fa fa-search" />
              </button>
            </form>
          </div>
        </li> */}
        {/* /Search */}
        {/* Flag */}

        {/* <li className="nav-item dropdown has-arrow flag-nav">
          <Link
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
          >
            <img src={flagImage} alt="Flag" height="20" /> {t(i18n.language)}
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("en")}
            >
              <img src={lnEnglish} alt="Flag" height="16" /> English
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("fr")}
            >
              <img src={lnFrench} alt="Flag" height="16" /> French
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("es")}
            >
              <img src={lnSpanish} alt="Flag" height="16" /> Spanish
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("de")}
            >
              <img src={lnGerman} alt="Flag" height="16" /> German
            </Link>
          </div>
        </li> */}
        {/* /Flag */}
        {/* Notifications */}
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleNotification}
          >
            <i>
              <FaRegBell />
            </i>{" "}
            {
              notificationCount>0&&
              <span className="badge badge-pill">{notificationCount}</span>

            }
          </Link>
          <div
          data-bs-auto-close="false"
          onClick={handleInsideClick}
            className={`dropdown-menu dropdown-menu-end notifications ${notification ? "show" : ""
              }`}
          >
            <div className="topnav-dropdown-header">
              <span className="notification-title">Notifications</span>
              
              <Link
                to="#"
                onClick={(e)=> filterNotifications(e,false)}
                // onClick={() => setNotifications(false)}
                className={`clear-noti cursor-pointer ms-2 ${isRead==="" && "text-dark"}`}
              >
                {" "}
                Unread{" "}
              </Link>

              
              <Link
                to="#"
                onClick={(e)=> filterNotifications(e,"")}
                // onClick={() => setNotifications(false)}
                className={`clear-noti cursor-pointer ${isRead===false && "text-dark"}`}
              >
                {" "}
                All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
              {
                  notifications.map((val, index) => {
                    return (
                      <li className="notification-message" key={index}>
                        <Link
                          onClick={(e) =>{
                            // e.stopPropagation()
                            console.log("JJJJJ")
                            // navigate("/employee-dashboard")
                            // localStorage.setItem("minheight", "true")

                          }
                          }
                          to={val?.data?.type == "leave_request" ?`/leaves-employee?id=${val.data?.id}&modal=true` : val?.data?.type == "expense_claim" && `/expenses?id=${val.data?.id}&modal=true`}
                        >
                          <div className="media d-flex">
                            <span className="avatar flex-shrink-0">
                            <i class={`fas text-primary ${val?.data?.type == "leave_request" ? "fa-calendar" : val?.data?.type == "expense_claim" && "fa-dollar-sign"}`}></i>
                            {/* <i class="fas fa-user-minus"></i> */}
                              {/* <Image type="user" src={""} /> */}
                            </span>
                            <div className="media-body">
                              <p className="noti-details">
                                {/* <span className="noti-title">{val.data?.user_name}</span>{" "} */}
                                {/* {val.data?.type}{" "} */}
                                <span className="noti-title">
                                  {val.title}
                                </span>
                              </p>
                              <p className="noti-time d-flex justify-content-between">
                                <span  data-bs-toggle="tooltip"
                          title={val.created_at}
                           className="notification-time">
  
                                  {timeSince(val.created_at)}
                                </span>
                                <Link 
                                className="cursor-pointer p-0 m-0" 
                                onClick={e=>{
                                  e.stopPropagation();
                                  if(!val?.is_read){
                                    viewNotificationHandler(val)
                                  }
                                  }} 
                                  >
                                {
                                  val?.is_read
                                  ?
                                  <i class="far fa-eye"></i>
                                  :
                                  <i class="far fa-eye-slash"></i>

                                }
                                </Link>
                                
                                
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })
                }
                
              </ul>
            </div>
            <div className="topnav-dropdown-header d-flex justify-content-center align-items-center">
            <Link
                to="#"
                onClick={()=>readDeleteNotification("delete")}

                // onClick={() => setNotifications(false)}
                className="clear-noti"
              >
                {" "}
                Clear All{" "}
              </Link>
              &nbsp;
              |
              &nbsp;
              <Link
                to="#"
                onClick={()=>readDeleteNotification("read")}
                // onClick={() => setNotifications(false)}
                className="clear-noti"
              >
                {" "}
                Read All{" "}
              </Link>

              {/* <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/app/administrator/activities"
              >
                View all Notifications
              </Link> */}
            </div>
          </div>
        </li>
        {/* /Notifications */}
        {/* Message Notifications */}
        {/* <li className={`nav-item dropdown ${isOpen ? "show" : ""}`}>
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={toggleDropdown}
          >
            <i>
              <FaRegComment />
            </i>{" "}
            <span className="badge badge-pill">0</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end notifications ${isOpen ? "show" : ""
              }`}
          >
            <div className="topnav-dropdown-header">
              <span className="notification-title">Messages</span>
              <Link to="#" className="clear-noti">
                {" "}
                Clear All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {datas.map((value, index) => {
                  return (
                    <li className="notification-message" key={index}>
                      <Link
                        onClick={() =>
                          localStorage.setItem("minheight", "true")
                        }
                        to="/conversation/chat"
                      >
                        <div className="list-item">
                          <div className="list-left">
                            <span className="avatar">
                              <img alt="" src={value.image} />
                            </span>
                          </div>
                          <div className="list-body">
                            <span className="message-author">{value.name}</span>
                            <span className="message-time">{value.time}</span>
                            <div className="clearfix" />
                            <span className="message-content">
                              {value.contents}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/conversation/chat"
              >
                View all Messages
              </Link>
            </div>
          </div>
        </li> */}
        {/* /Message Notifications */}
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
          >
            {" "}
            <span className="user-img me-1">
              <Image type="user" src={user?.profile_image} alt="img" style={{ objectFit: "cover" }} />
              <span className="status online" />
            </span>
            <span>{ProfileName ? `${ProfileName}` : "Admin"}</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end ${profile ? "show" : ""
              }`}
          >
            
            {/* <Link className="dropdown-item" to="/settings/companysetting">
              Settings
            </Link> */}
            {
              user?.role?.access_scope !== "store_manager" && 
              <Link 
          
           className="dropdown-item"  
           to={ user?.role?.access_scope == "store_manager" ? "#" : `/employees/${user?.id}?profile=true`} 
           onClick={(e) => user?.role?.access_scope == "store_manager" && e.preventDefault()} 
           >
          <span className=" d-flex my-1">
          <div   className="avatar">
            <Image src={user.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </div>
          <div className="ms-2">
          <div className="d-flex flex-column">
            <span className="fw-bold">{user?.first_name} {user?.last_name}</span>
            <span className="small text-muted">{user?.role?.name || "User"}</span>
            {user.emp_no && <span className="small text-muted">{user.emp_no}</span>}
            <span className="small text-muted">{user?.email || ""}</span>
          </div>
          </div>
        </span>
       

            {/* My Profile */}
          </Link>
          
            //   <Link className="dropdown-item" to={`/employees/${user?.id}`}>
            //   My Profile
            // </Link>
            }
            <Link style={{borderTop:"1px solid #e0e0e0"}} className="dropdown-item" to="/" onClick={handleLogout} >
              Logout
            </Link>
          </div>
        </li>
      </ul>
      {/* /Header Menu */}
      {/* Mobile Menu */}
      


     















      <li className="me-5 dropdown mobile-user-menu">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleNotification}
          >
            <i>
              <FaRegBell />
            </i>{" "}
            {
              notificationCount>0&&
              <span className="badge badge-pill">{notificationCount}</span>

            }
          </Link>
          <div
          data-bs-auto-close="false"
          onClick={handleInsideClick}
            className={`dropdown-menu dropdown-menu-end notifications ${notification ? "show" : ""
              }`}
          >
            <div className="topnav-dropdown-header">
              <span className="notification-title">Notifications</span>
              
              <Link
                to="#"
                onClick={(e)=> filterNotifications(e,false)}
                // onClick={() => setNotifications(false)}
                className={`clear-noti cursor-pointer ms-2 ${isRead==="" && "text-dark"}`}
              >
                {" "}
                Unread{" "}
              </Link>

              
              <Link
                to="#"
                onClick={(e)=> filterNotifications(e,"")}
                // onClick={() => setNotifications(false)}
                className={`clear-noti cursor-pointer ${isRead===false && "text-dark"}`}
              >
                {" "}
                All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
              {
                  notifications.map((val, index) => {
                    return (
                      <li className="notification-message" key={index}>
                        <Link
                          onClick={(e) =>{
                            // e.stopPropagation()
                            console.log("JJJJJ")
                            // navigate("/employee-dashboard")
                            // localStorage.setItem("minheight", "true")

                          }
                          }
                          to={val?.data?.type == "leave_request" ?`/leaves-employee?id=${val.data?.id}&modal=true` : val?.data?.type == "expense_claim" && `/expenses?id=${val.data?.id}&modal=true`}
                        >
                          <div className="media d-flex">
                            <span className="avatar flex-shrink-0">
                            <i class={`fas text-primary ${val?.data?.type == "leave_request" ? "fa-calendar" : val?.data?.type == "expense_claim" && "fa-dollar-sign"}`}></i>
                            {/* <i class="fas fa-user-minus"></i> */}
                              {/* <Image type="user" src={""} /> */}
                            </span>
                            <div className="media-body">
                              <p className="noti-details">
                                {/* <span className="noti-title">{val.data?.user_name}</span>{" "} */}
                                {/* {val.data?.type}{" "} */}
                                <span className="noti-title">
                                  {val.title}
                                </span>
                              </p>
                              <p className="noti-time d-flex justify-content-between">
                                <span  data-bs-toggle="tooltip"
                          title={val.created_at}
                           className="notification-time">
  
                                  {timeSince(val.created_at)}
                                </span>
                                <Link 
                                className="cursor-pointer p-0 m-0" 
                                onClick={e=>{
                                  e.stopPropagation();
                                  if(!val?.is_read){
                                    viewNotificationHandler(val)
                                  }
                                  }} 
                                  >
                                {
                                  val?.is_read
                                  ?
                                  <i class="far fa-eye"></i>
                                  :
                                  <i class="far fa-eye-slash"></i>

                                }
                                </Link>
                                
                                
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })
                }
                
              </ul>
            </div>
            <div className="topnav-dropdown-header d-flex justify-content-center align-items-center">
            <Link
                to="#"
                onClick={()=>readDeleteNotification("delete")}

                // onClick={() => setNotifications(false)}
                className="clear-noti"
              >
                {" "}
                Clear All{" "}
              </Link>
              &nbsp;
              |
              &nbsp;
              <Link
                to="#"
                onClick={()=>readDeleteNotification("read")}
                // onClick={() => setNotifications(false)}
                className="clear-noti"
              >
                {" "}
                Read All{" "}
              </Link>

              {/* <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/app/administrator/activities"
              >
                View all Notifications
              </Link> */}
            </div>
          </div>
        </li>





      <div 
      // style={{width:95}} 
      className="dropdown mobile-user-menu me-2 ">
      
    




        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {
            user.profile_image ?
            <div   className="avatar">
            <Image src={user.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </div>:
          <div  style={{width:40,height:40, backgroundColor:"white", borderRadius:"50%"}} className="avatar text-sm text-normal text-danger">
        {/* <div className=" d-flex justify-content-center align-items-center text-capitalize text-danger" style={{width:40,height:40, backgroundColor:"white", borderRadius:"50%"}}> */}
         <span>{user?.first_name&&user?.first_name[0]}{user?.last_name ? user?.last_name[0]:""}</span> 
        {/* </div> */}
        </div>

          }
          
          {/* <i className="fa fa-ellipsis-v" /> */}
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link 
          
           className="dropdown-item"  
           to={ user?.role?.access_scope == "store_manager" ? "#" : `/employees/${user?.id}?profile=true`} 
           onClick={(e) => user?.role?.access_scope == "store_manager" && e.preventDefault()} 
           >
          <span className=" d-flex my-1">
          <div   className="avatar">
            <Image src={user.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </div>
          <div className="ms-2">
          <div className="d-flex flex-column">
            <span className="fw-bold lh-sm">{user?.first_name} {user?.last_name}</span>
            <span className="small text-muted lh-sm">{user?.role?.name || "User"}</span>
            {user.emp_no && <span className="small text-muted lh-sm">{user.emp_no}</span>}
            <span className="small text-muted lh-sm">{user?.email || ""}</span>
          </div>
          </div>
        </span>

            {/* My Profile */}
          </Link>
          {/* <Link className="dropdown-item" to="/settings/companysetting">
            Settings
          </Link> */}
          <Link className="dropdown-item" to="/"  onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
      {/* /Mobile Menu */}
    </div>
  );
};

export default Header;
